// import Swiper from "swiper"
import { find } from "../utils/dom"

export default function () {
	const Home = find("[js-page='join-now']")
	if (!Home) return
	console.log('Page home Joiw Now');

	var swiperSpeedVertical = new Swiper(".swiper-speed-vertical", {
      	spaceBetween: 24,
				slidesPerView: 2.8,
				direction: "vertical",
				loop:true,
				speed: 500,
  			effect: 'slide', 
					autoplay: {
						delay: 1000,
						disableOnInteraction: false,
					}
    });

	var swiperCardsMobile = new Swiper(".swiper-cards-mobile", {
		spaceBetween: 20,
		slidesPerView: 1.2,

    });


	const toggleFaqMobile = () =>{
			const faqs = document.querySelectorAll('[data-toggle-faq]')
		
			faqs.forEach(faq=>{
					faq.addEventListener('click', (e)=>{
							const svg = faq.querySelector('svg')
							const paragraph = faq.querySelector('p');
							svg.classList.toggle('rotate-180')
							paragraph.classList.toggle('toggle-active')
							console.log(paragraph);
							
					})
			})
	}

	toggleFaqMobile()
}